import React from 'react'
import '../styles/header.css'
import logo from '../images/logo.svg'
import {MdMoreVert} from 'react-icons/md'
const Nav = () => {
	return <>
		<nav className="header">
      <input type="checkbox" id="check" />
      <label htmlFor="check" className="checkbtn">
        <i className="fas fa-bars"></i>
      </label>
      <label className="logo"><img src={logo} /></label>
      <ul className="header__ul">
        <li><a className="active" href="#">Home</a></li>
        <li><a href="#">About</a></li>
        <li><a href="#">Services</a></li>
        <li><a href="#">Contact</a></li>
        <li><a href="#">Feedback</a></li>
      </ul>
    </nav>

	</>
}

export default Nav;